import { MinhaAgenda } from '@app/models/minha-agenda';
import { Component, Input, Output } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';

import { MeAvise } from '@app/models/me-avise';
import { EventEmitter } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mov-me-avise',
  templateUrl: './mov-me-avise.component.html',
  styleUrls: ['./mov-me-avise.component.scss'],
})
export class MovMeAviseComponent {
  @Input() meAvises: MeAvise[] = [];
  @Input() listaMeAviseIndexSucesso: number[] = [];
  @Input() lstUsuarios: IdDescricao[] = [];
  @Input() lstMeAviseTipo: IdDescricao[] = [];
  @Input() exibirTipoMeAvise: boolean;
  @Output() modificaNomeAdvogado = new EventEmitter();
  @Input() editar = false;
  @Input() form = false;
  @Input() agenda: MinhaAgenda = new MinhaAgenda();
  @Input() processoArquivado: boolean = false;
  @Output() tamanhoMeAvise = new EventEmitter();

  cdsMask: CDSMask = new CDSMask();
  podeEditarPrazoMeAvise = true;
  exibir = false;
  dataInvalida = true;
  todayDate = UtilitarioService.retornaDataAtualMaisDiasISO(0);
  prazoMin = UtilitarioService.retornaDataAtualMaisDiasISO(0);
  private toastr: ToastrService

  exibirFormulario(event: Event): void {
    event.preventDefault();
    this.exibir = !this.exibir;

    if (this.meAvises.length === 0) {
      this.meAvises.push(
        new MeAvise(new Date().toISOString().split('T')[0])
      );
    }
  }

  adicionar(data: string): void {
    this.meAvises.push(new MeAvise());
    this.tamanhoMeAvise.emit(this.meAvises.length);

    this.focaCampoDataUltimoMeAvise();
  }

  remover(index: number): void {
    this.meAvises.splice(index, 1);
    this.tamanhoMeAvise.emit(this.meAvises.length);

    this.focaCampoDataUltimoMeAvise(index);
  }

  focaCampoDataUltimoMeAvise(index: number = -1): void {
    const stringUltimo = `meAvise.Data${this.meAvises.length - 1}`;
    const stringIndex = `meAvise.Data${index === 0 ? 0 : index - 1}`

    window.setTimeout(
      () => document.getElementById(index === -1 ? stringUltimo : stringIndex).focus(),
      0
    );
  }

  respostaMudarAdvNome(advogado: any): void {
    this.modificaNomeAdvogado.emit(advogado);
  }

  dateChange(data): void {
    this.prazoMin = data;
  }

  timeChange(data, hora, id): void {
    const inputDateAndTime = new Date(data + 'T' + hora);

    const dataAtual = this.dataAtual(data);

    if (dataAtual) {
      const today = new Date();
      if (inputDateAndTime < today) {
        this.meAvises.forEach((item) => {
          if (item.Id === id) {
            const dataHoje = new Date().toLocaleString();

            const horario = dataHoje.split(' ')[1];
            item.Horario = horario.replace(/(\d{1,2}):(\d{2}):(\d{2})/, '$1:$2');
          }
        });
      }
    }
  }

  private dataAtual(data): boolean {
    const inputDateOnlyDay = new Date(data + 'T00:00:00');
    const today = new Date();

    if (inputDateOnlyDay.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
      return true;
    } else {
      return false;
    }
  }

  

  colarData(evento: Event, index: number): void {
    let eventoDoTeclado = evento as KeyboardEvent;
    if (eventoDoTeclado.key.toLowerCase() === "v") {
      navigator.clipboard
      .readText()
      .then((textAreatranferencia) => {
          if(textAreatranferencia.match('-')){
            var trocar= textAreatranferencia.split('-').reverse().join('-')
            this.meAvises[index].Data = trocar;
          }else{
            var trocar= textAreatranferencia.split('/').reverse().join('-')
            this.meAvises[index].Data= trocar;
            }})
        .catch((err) => {
          this.toastr.error("Sem item na área de transferência.",err);

        });
    }

  }
}
